module.exports = __webpack_public_path__ + "img/logo_black.12ca2680.png";